import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';
import queryString from 'query-string';

import { generateAuthHeaders } from '@src/factories';

import Client from './client';
import { Suggestion } from './types';

type Response = {
  readonly result: 'SUCCESS' | 'ERROR';
  readonly status: number;
  readonly suggestions: Suggestion[];
};

export default (
  accessToken: string,
  offset: number = 0,
  limit: number = 20,
  config?: AxiosRequestConfig
) => {
  return Client.get<Response>(
    `/fs/v1/suggestions?${queryString.stringify({
      offset,
      limit,
    })}`,
    merge(config, generateAuthHeaders(accessToken))
  );
};
